module.exports = __webpack_public_path__ + "static/img/process5.4b152c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/process/process5.jpg
// module id = K8ag
// module chunks = 0